import { UI_ROLE_TYPE } from '../types';
import { RoleType } from '@bmwe/data/kwg/graphql';

export const roleTypeOptions = [
  { name: UI_ROLE_TYPE.NONE, value: 'none' },
  { name: UI_ROLE_TYPE.ADMINISTRATOR, value: RoleType.Administrator },
  { name: UI_ROLE_TYPE.CONTRIBUTOR, value: RoleType.Contributor },
  { name: UI_ROLE_TYPE.EDITOR, value: RoleType.Editor },
  { name: UI_ROLE_TYPE.READER, value: RoleType.Reader },
] as const;
